import styled from 'styled-components';
import {Checkbox} from "antd";

interface CustomAntCheckboxProps {
    color?: string,
    checked?: boolean
}

export const CustomAntCheckbox = styled(Checkbox)<CustomAntCheckboxProps>`
    .ant-checkbox-checked .ant-checkbox-inner {
        background-color: white;
        border-color: ${ props => props.color ? props.color : '#47592F' };
        border-width: 1.8px;

    }
    .ant-checkbox-checked .ant-checkbox-inner:after {
        border-color: ${ props => props.color ? props.color : '#47592F' } !important;
    }
    .ant-checkbox-wrapper:hover .ant-checkbox-inner,
    .ant-checkbox-checked:hover .ant-checkbox-inner,
    .ant-checkbox:hover .ant-checkbox-inner,
    .ant-checkbox-input:focus + .ant-checkbox-inner{
        border: 1.8px solid ${ props => props.color ? props.color : '#47592F' } !important;
    }
`;

export const CustomCheckboxSmall = styled(CustomAntCheckbox)`
    margin-right: 5px;
    //scale: 0.5;
    transform: scale(0.80);

    .ant-checkbox-checked .ant-checkbox-inner {
        background-color: white;
        border-color: rgba(124, 190, 123, 1);;
        border-width: 1.8px;

    }

    .ant-checkbox-checked .ant-checkbox-inner:after {
        border-color: rgba(124, 190, 123, 1) !important;
    }

    .ant-checkbox-wrapper:hover .ant-checkbox-inner,
    .ant-checkbox-checked:hover .ant-checkbox-inner,
    .ant-checkbox:hover .ant-checkbox-inner,
    .ant-checkbox-input:focus + .ant-checkbox-inner {
        border: 1.8px solid rgba(124, 190, 123, 1) !important;
    }
`;


